import React from 'react'
import RoomFacilitesTable from './Components/RoomFacilitesTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const RoomFacilitiesList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Room Facilites List</HeadingOne>
          <AddItemBtn url="add-room-facilites" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <RoomFacilitesTable />
      </div>
    </PageBody>
  );
};

export default RoomFacilitiesList;
